import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

interface TimerDisplayProps {
  getSeconds: () => number;
  isRefreshing: boolean;
}

export const TimerDisplay = ({
  getSeconds,
  isRefreshing,
}: TimerDisplayProps) => {
  const [displaySeconds, setDisplaySeconds] = useState(() => getSeconds());

  useEffect(() => {
    // Update immediately when not refreshing
    if (!isRefreshing) {
      setDisplaySeconds(getSeconds());
    }
  }, [isRefreshing, getSeconds]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isRefreshing) {
        setDisplaySeconds(getSeconds());
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [getSeconds, isRefreshing]);

  return (
    <Box
      sx={{
        fontSize: "14px",
        color: (theme) => theme.palette.text.secondary,
        textAlign: "center",
        padding: "8px",
        backgroundColor: (theme) => theme.palette.billetYard.backgrounds.light,
        borderRadius: "4px",
        minWidth: "150px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          color: (theme) =>
            isRefreshing
              ? theme.palette.warning.main
              : theme.palette.text.secondary,
          fontWeight: isRefreshing ? 500 : 400,
        }}
      >
        {isRefreshing ? "Refreshing..." : `Next refresh in ${displaySeconds}s`}
      </Typography>
    </Box>
  );
};
